import { TFooterV2Links } from '../types'

export const TopIndianStocksColumns = [
  {
    title: '1-5',
    listItem: [
      {
        title: 'Tata Motors',
        relative_path: '/stocks/tata-motors-ltd-share-price',
      },
      {
        title: 'Zomato',
        relative_path: '/stocks/zomato-ltd-share-price',
      },
      {
        title: 'Tata Power',
        relative_path: '/stocks/tata-power-company-ltd-share-price',
      },
      {
        title: 'NHPC',
        relative_path: '/stocks/nhpc-ltd-share-price',
      },
      {
        title: 'Reliance Industries',
        relative_path: '/stocks/reliance-industries-ltd-share-price',
      },
    ],
  },
  {
    title: '6-10',
    listItem: [
      {
        title: 'IRCTC',
        relative_path:
          '/stocks/indian-railway-catering-and-tourism-corporation-ltd-share-price',
      },
      {
        title: 'IRFC',
        relative_path:
          '/stocks/indian-railway-finance-corporation-ltd-share-price',
      },
      {
        title: 'Yes Bank',
        relative_path: '/stocks/yes-bank-ltd-share-price',
      },
      {
        title: 'Tata Steel',
        relative_path: '/stocks/tata-steel-ltd-share-price',
      },
      {
        title: 'Reliance Power',
        relative_path: '/stocks/reliance-power-ltd-share-price',
      },
    ],
  },
  {
    title: '11-15',
    listItem: [
      {
        title: 'Suzlon',
        relative_path: '/stocks/suzlon-energy-ltd-share-price',
      },
      {
        title: 'LIC',
        relative_path:
          '/stocks/life-insurance-corporation-of-india-share-price',
      },
      {
        title: 'Adani Green Energy',
        relative_path: '/stocks/adani-green-energy-ltd-share-price',
      },
      {
        title: 'Adani Power',
        relative_path: '/stocks/adani-power-ltd-share-price',
      },
      {
        title: 'HDFC Bank',
        relative_path: '/stocks/hdfc-bank-ltd-share-price',
      },
    ],
  },
  {
    title: '16-20',
    listItem: [
      {
        title: 'Ashok Leyland',
        relative_path: '/stocks/ashok-leyland-ltd-share-price',
      },
      {
        title: 'Vedanta',
        relative_path: '/stocks/vedanta-ltd-share-price',
      },
      {
        title: 'SBI',
        relative_path: '/stocks/state-bank-of-india-share-price',
      },
      {
        title: 'BPCL',
        relative_path: '/stocks/bharat-petroleum-corporation-ltd-share-price',
      },
      {
        title: 'SAIL',
        relative_path: '/stocks/steel-authority-of-india-ltd-share-price',
      },
    ],
  },
]

export const IndianStocksCategoryColumns = [
  {
    title: 'Market Performance & Trends',
    listItem: [
      {
        title: "Today's Share Market",
        relative_path: '/market',
      },
      {
        title: 'Top Gainers',
        relative_path: '/stocks/category/top-gainers',
      },
      {
        title: 'Top Losers',
        relative_path: '/stocks/category/top-losers',
      },
      {
        title: '52 Week High Stocks',
        relative_path: '/stocks/category/52-week-high',
      },
      {
        title: '52 Week Low Stocks',
        relative_path: '/stocks/category/52-week-low',
      },
      {
        title: 'Nifty 50 Stocks',
        relative_path: '/stocks/category/nifty-50-stocks',
      },
    ],
  },
  {
    title: 'Investment Opportunities & Strategies',
    listItem: [
      {
        title: 'Penny Stocks',
        relative_path: '/stocks/category/penny-stocks',
      },
      {
        title: 'Stocks to Buy Today',
        relative_path: '/stocks/category/buy-stocks',
      },
      {
        title: 'Dividend Stocks',
        relative_path: '/stocks/category/dividend-stocks',
      },
      {
        title: 'Bonus Shares',
        relative_path: '/stocks/category/bonus-shares',
      },
      {
        title: 'Multibagger Stocks',
        relative_path: '/stocks/category/multibagger-stocks',
      },
    ],
  },
  {
    title: 'Top Sectors',
    listItem: [
      {
        title: 'Blue Chip Stocks',
        relative_path: '/stocks/category/blue-chip-stocks',
      },
      {
        title: 'PSU Stocks',
        relative_path: '/stocks/category/psu-stocks',
      },
      {
        title: 'Defence Stocks',
        relative_path: '/stocks/category/defence',
      },
      {
        title: 'EV Stocks',
        relative_path: '/stocks/category/ev-stocks',
      },
      {
        title: 'Ethanol Stocks',
        relative_path: '/stocks/category/ethanol-stocks',
      },
    ],
  },
  {
    title: 'Group Stocks',
    listItem: [
      {
        title: 'Adani Shares',
        relative_path: '/stocks/category/adani-group-shares',
      },
      {
        title: 'HDFC Shares',
        relative_path: '/stocks/category/hdfc-group-shares',
      },
      {
        title: 'Tata Shares',
        relative_path: '/stocks/category/tata-group-shares',
      },
      {
        title: 'Bajaj Shares',
        relative_path: '/stocks/category/bajaj-group-shares',
      },
      {
        title: 'Ambani Shares',
        relative_path: '/stocks/category/ambani-group-shares',
      },
    ],
  },
]

export const TopIndicesColumns = [
  {
    title: 'Broad Market Indices',
    listItem: [
      {
        title: 'NIFTY 50',
        relative_path: '/indices/nifty-50',
      },
      {
        title: 'NIFTY 500',
        relative_path: '/indices/nifty-500',
      },
      {
        title: 'NIFTY Midcap 100',
        relative_path: '/indices/nifty-midcap-100',
      },
      {
        title: 'BSE Sensex',
        relative_path: '/indices/sensex',
      },
      {
        title: 'BANKEX',
        relative_path: '/indices/bankex',
      },
      {
        title: 'BSE 500',
        relative_path: '/indices/bse-500',
      },
    ],
  },
  {
    title: 'Sectoral Indices',
    listItem: [
      {
        title: 'NIFTY Bank',
        relative_path: '/indices/bank-nifty',
      },
      {
        title: 'FIN Nifty',
        relative_path: '/indices/nifty-financial',
      },
      {
        title: 'Nifty IT',
        relative_path: '/indices/nifty-it',
      },
      {
        title: 'Nifty Pharma',
        relative_path: '/indices/nifty-pharma',
      },
      {
        title: 'Nifty Auto',
        relative_path: '/indices/nifty-auto',
      },
    ],
  },
  {
    title: 'Thematic Indices',
    listItem: [
      {
        title: 'NIFTY CPSE',
        relative_path: '/indices/nifty-cpse',
      },
      {
        title: 'NIFTY Infrastructure',
        relative_path: '/indices/nifty-infra',
      },
      {
        title: 'NIFTY MNC',
        relative_path: '/indices/nifty-mnc',
      },
      {
        title: 'NIFTY Commodities',
        relative_path: '/indices/nifty-commodities',
      },
      {
        title: 'NIFTY Energy',
        relative_path: '/indices/nifty-energy',
      },
    ],
  },
  {
    title: 'Global Indices',
    listItem: [
      {
        title: 'Gift Nifty',
        relative_path: '/indices/global-indices/gift-nifty',
      },
      {
        title: 'Dow Jones Industrial Average',
        relative_path: '/indices/global-indices/dow-jones-industrial-average',
      },
      {
        title: 'S&P 500',
        relative_path: '/indices/global-indices/s-p-500',
      },
      {
        title: 'Russell 2000 Index',
        relative_path: '/indices/global-indices/russell-2000-index',
      },
      {
        title: 'Dow Jones Market',
        relative_path: '/indices/global-indices/dow-jones-market',
      },
    ],
  },
]

export const MoreColumns = [
  {
    title: 'IPOs',
    listItem: [
      {
        title: 'IPO',
        relative_path: '/ipo',
      },
      {
        title: 'IPO Allotment Status',
        relative_path: '/ipo/ipo-allotment-status',
      },
      {
        title: 'Recently Listed IPO',
        relative_path: '/ipo/recently-listed-ipos',
      },
    ],
  },
  {
    title: 'ETFs',
    listItem: [
      {
        title: 'ETFs',
        relative_path: '/stocks/etf',
      },
      {
        title: 'Gold ETFs',
        relative_path: '/stocks/category/gold-etfs',
      },
      {
        title: 'CPSE ETF',
        relative_path: '/stocks/cpse-etf-share-price',
      },
      {
        title: 'Bharat 22 ETF',
        relative_path: '/stocks/bharat-22-etf-share-price',
      },
      {
        title: 'Nippon India Silver ETF',
        relative_path: '/stocks/nippon-india-silver-etf-share-price',
      },
    ],
  },
  {
    title: 'Gold Rates',
    listItem: [
      {
        title: 'Gold Rates in India',
        relative_path: '/gold-rates',
      },
      {
        title: 'Delhi',
        relative_path: '/gold-rates/delhi',
      },
      {
        title: 'Mumbai',
        relative_path: '/gold-rates/mumbai',
      },
      {
        title: 'Bangalore',
        relative_path: '/gold-rates/bangalore',
      },
      {
        title: 'Pune',
        relative_path: '/gold-rates/pune',
      },
    ],
  },
]

export const TopMutualFundsColumns = [
  {
    title: 'Equity Funds',
    listItem: [
      {
        title: 'SBI Energy Opportunities Fund',
        relative_path:
          '/mutual-funds/fund/sbi-energy-opportunities-fund-direct-growth/1044857',
      },
      {
        title: 'Quant Small Cap Fund',
        relative_path:
          '/mutual-funds/fund/quant-small-cap-fund-growth-option-direct-plan/611',
      },
      {
        title: 'Parag Parikh Flexi-cap Fund',
        relative_path:
          '/mutual-funds/fund/parag-parikh-flexi-cap-direct-growth/3229',
      },
      {
        title: 'JM Small Cap Fund',
        relative_path:
          '/mutual-funds/fund/jm-small-cap-fund-direct-growth/1045777',
      },
      {
        title: 'Motilal Oswal Multi Cap Fund',
        relative_path:
          '/mutual-funds/fund/motilal-oswal-multi-cap-fund-direct-growth/1045938',
      },
    ],
  },
  {
    title: 'Debt Funds',
    listItem: [
      {
        title: 'Mahindra Manulife Liquid Fund',
        relative_path:
          '/mutual-funds/fund/mahindra-manulife-liquid-fund-direct-plan-growth/1200',
      },
      {
        title: 'HDFC Low Duration',
        relative_path:
          '/mutual-funds/fund/hdfc-low-duration-direct-plan-growth-option/1481',
      },
      {
        title: 'UTI Short Duration',
        relative_path:
          '/mutual-funds/fund/uti-short-duration-fund-direct-plan-growth-option/2316',
      },
      {
        title: 'Aditya Birla Sun Life Corporate Bond',
        relative_path:
          '/mutual-funds/fund/aditya-birla-sun-life-corporate-bond-fund-direct-plan-growth/4676',
      },
      {
        title: 'Kotak Dynamic Bond',
        relative_path:
          '/mutual-funds/fund/kotak-dynamic-bond-direct-growth/5069',
      },
    ],
  },
  {
    title: 'Hybrid Funds',
    listItem: [
      {
        title: 'ICICI Prudential Bharat 22 FOF',
        relative_path:
          '/mutual-funds/fund/icici-prudential-bharat-22-fof-direct-growth/5380',
      },
      {
        title: 'SBI Equity Hybrid Fund',
        relative_path:
          '/mutual-funds/fund/sbi-equity-hybrid-fund-direct-growth/4170',
      },
      {
        title: 'ICICI Prudential Multi-Asset Fund',
        relative_path:
          '/mutual-funds/fund/icici-prudential-multi-asset-fund-direct-plan-growth/4646',
      },
      {
        title: 'ICICI Prudential Equity & Debt Fund',
        relative_path:
          '/mutual-funds/fund/icici-prudential-equity-debt-fund-direct-plan-growth/4108',
      },
    ],
  },
  {
    title: 'Index Funds',
    listItem: [
      {
        title: 'Motilal Oswal Nifty India Defence Index Fund',
        relative_path:
          '/mutual-funds/fund/motilal-oswal-nifty-india-defence-index-fund-direct-growth/1046132',
      },
      {
        title: 'Motilal Oswal S&P 500 Index Fund',
        relative_path:
          '/mutual-funds/fund/motilal-oswal-sp-500-index-fund-direct-growth/1005898',
      },
      {
        title: 'Navi Nifty 50 Index Fund',
        relative_path:
          '/mutual-funds/fund/navi-nifty-50-index-fund-direct-growth/1039539',
      },
      {
        title: 'UTI Nifty 50 Index Fund',
        relative_path:
          '/mutual-funds/fund/uti-nifty-50-index-fund-growth-option-direct/5603',
      },
    ],
  },
]

export const TopMutualFundAMCsColumns = [
  {
    title: '1-5',
    listItem: [
      {
        title: 'Quant Mutual Fund',
        relative_path: '/mutual-funds/amc/quant-mutual-fund',
      },
      {
        title: 'Tata Mutual Fund',
        relative_path: '/mutual-funds/amc/tata-mutual-fund',
      },
      {
        title: 'Kotak Mutual Fund',
        relative_path: '/mutual-funds/amc/kotak-mutual-fund',
      },
      {
        title: 'HDFC Mutual Fund',
        relative_path: '/mutual-funds/amc/hdfc-mutual-fund',
      },
      {
        title: 'Aditya Birla Mutual Fund',
        relative_path: '/mutual-funds/amc/aditya-birla-mutual-fund',
      },
    ],
  },
  {
    title: '6-10',
    listItem: [
      {
        title: 'ICICI Prudential Mutual Fund',
        relative_path: '/mutual-funds/amc/icici-prudential-mutual-fund',
      },
      {
        title: 'UTI Mutual Fund',
        relative_path: '/mutual-funds/amc/uti-mutual-fund',
      },
      {
        title: 'DSP Mutual Fund',
        relative_path: '/mutual-funds/amc/dsp-mutual-fund',
      },
      {
        title: 'SBI Mutual Fund',
        relative_path: '/mutual-funds/amc/sbi-mutual-fund',
      },
      {
        title: 'Edelweiss Mutual Fund',
        relative_path: '/mutual-funds/amc/edelweiss-mutual-fund',
      },
    ],
  },
  {
    title: '11-15',
    listItem: [
      {
        title: 'Nippon India Mutual Fund',
        relative_path: '/mutual-funds/amc/nippon-india-mutual-fund',
      },
      {
        title: 'Sundaram Mutual Fund',
        relative_path: '/mutual-funds/amc/sundaram-mutual-fund',
      },
      {
        title: 'Mirae Asset Mutual Fund',
        relative_path: '/mutual-funds/amc/mirae-asset-mutual-fund',
      },
      {
        title: 'Axis Mutual Fund',
        relative_path: '/mutual-funds/amc/axis-mutual-fund',
      },
      {
        title: 'Parag Parikh Mutual Fund',
        relative_path: '/mutual-funds/amc/parag-parikh-mutual-fund',
      },
    ],
  },
  {
    title: '16-20',
    listItem: [
      {
        title: 'Canara Robeco Mutual Fund',
        relative_path: '/mutual-funds/amc/canara-robeco-mutual-fund',
      },
      {
        title: 'PGIM Mutual Fund',
        relative_path: '/mutual-funds/amc/pgim-mutual-fund',
      },
      {
        title: 'Navi Mutual Fund',
        relative_path: '/mutual-funds/amc/navi-mutual-fund',
      },
      {
        title: 'Invesco Mutual Fund',
        relative_path: '/mutual-funds/amc/invesco-mutual-fund',
      },
      {
        title: 'Motilal Oswal Mutual Fund',
        relative_path: '/mutual-funds/amc/motilal-oswal-mutual-fund',
      },
    ],
  },
]

export const MutualFundsCategoryColumns = [
  {
    title: 'Equity Funds',
    listItem: [
      {
        title: 'Large Cap',
        relative_path: '/mutual-funds/equity/large-cap-funds',
      },
      {
        title: 'Mid Cap',
        relative_path: '/mutual-funds/equity/mid-cap-funds',
      },
      {
        title: 'Small Cap',
        relative_path: '/mutual-funds/equity/small-cap-funds',
      },
      {
        title: 'Nifty 50 Index Fund',
        relative_path: '/mutual-funds/equity/nifty-50-index-funds',
      },
      {
        title: 'Nifty Next 50 Index Fund',
        relative_path: '/mutual-funds/equity/nifty-next-50-index-funds',
      },
      {
        title: 'Global Index Funds',
        relative_path: '/mutual-funds/equity/global-index-funds',
      },
    ],
  },
  {
    title: 'Debt Funds',
    listItem: [
      {
        title: 'Liquid Funds',
        relative_path: '/mutual-funds/debt/liquid-funds',
      },
      {
        title: 'Corporate Bonds',
        relative_path: '/mutual-funds/debt/corporate-bond-funds',
      },
      {
        title: 'Money Market',
        relative_path: '/mutual-funds/debt/money-market-funds',
      },
      {
        title: 'Bank & PSU',
        relative_path: '/mutual-funds/debt/banking-psu',
      },
      {
        title: 'Overnight Funds',
        relative_path: '/mutual-funds/debt/overnight',
      },
    ],
  },
  {
    title: 'Hybrid Funds',
    listItem: [
      {
        title: 'Arbitrage',
        relative_path: '/mutual-funds/hybrid/arbitrage-funds',
      },
      {
        title: 'Balanced',
        relative_path: '/mutual-funds/hybrid/balanced-funds',
      },
      {
        title: 'Multi Asset Allocation',
        relative_path: '/mutual-funds/hybrid/multi-asset-funds',
      },
      {
        title: 'Fund of Funds',
        relative_path: '/mutual-funds/hybrid/fund-of-funds',
      },
      {
        title: 'Retirement Fund',
        relative_path: '/mutual-funds/hybrid/retirement',
      },
    ],
  },
  {
    title: 'Collections',
    listItem: [
      {
        title: 'Trending Funds',
        relative_path: '/mutual-funds/collection/investors-choice',
      },
      {
        title: 'Best SIP Funds',
        relative_path: '/mutual-funds/collection/best-sip-funds',
      },
      {
        title: 'ELSS Funds',
        relative_path: '/mutual-funds/collection/elss-funds',
      },
      {
        title: 'Gold Funds',
        relative_path: '/mutual-funds/collection/precious-metals-funds',
      },
      {
        title: 'High Return Funds',
        relative_path: '/mutual-funds/collection/high-return-mutual-funds',
      },
    ],
  },
]

export const ToolsAndCalculatorsColumns = [
  {
    title: '1-5',
    listItem: [
      {
        title: 'SIP Calculator',
        relative_path: '/calculators/sip-calculator',
      },
      {
        title: 'Compound Interest Calculator',
        relative_path: '/calculators/compound-interest-calculator',
      },
      {
        title: 'EMI Calculator',
        relative_path: '/calculators/emi-calculator',
      },
      {
        title: 'Home Loan EMI Calculator',
        relative_path: '/calculators/home-loan-emi-calculator',
      },
      {
        title: 'GST Calculator',
        relative_path: '/calculators/gst-calculator',
      },
    ],
  },
  {
    title: '6-10',
    listItem: [
      {
        title: 'Gratuity Calculator',
        relative_path: '/calculators/gratuity-calculator',
      },
      {
        title: 'Lumpsum Calculator',
        relative_path: '/calculators/lumpsum-calculator',
      },
      {
        title: 'Personal Loan EMI Calculator',
        relative_path: '/calculators/personal-loan-emi-calculator',
      },
      {
        title: 'Car Loan EMI Calculator',
        relative_path: '/calculators/car-loan-emi-calculator',
      },
      {
        title: 'Income Tax Calculator',
        relative_path: '/calculators/income-tax-calculator',
      },
    ],
  },
  {
    title: '11-15',
    listItem: [
      {
        title: 'HRA Calculator',
        relative_path: '/calculators/hra-calculator',
      },
      {
        title: 'NPS Calculator',
        relative_path: '/calculators/nps-calculator',
      },
      {
        title: 'Sukanya Samriddhi Yojana Calculator',
        relative_path: '/calculators/ssy-calculator',
      },
      {
        title: 'Discount Calculator',
        relative_path: '/calculators/discount-calculator',
      },
      {
        title: 'Post Office RD Calculator',
        relative_path: '/calculators/post-office-rd-calculator',
      },
    ],
  },
  {
    title: '16-20',
    listItem: [
      {
        title: 'SWP Calculator',
        relative_path: '/calculators/swp-calculator',
      },
      {
        title: 'PPF Calculator',
        relative_path: '/calculators/ppf-calculator',
      },
      {
        title: 'Interest Rate Calculator',
        relative_path: '/calculators/interest-rate-calculator',
      },
      {
        title: 'CAGR Calculator',
        relative_path: '/calculators/cagr-calculator',
      },
      {
        title: 'Simple Interest Calculator',
        relative_path: '/calculators/simple-interest-calculator',
      },
    ],
  },
]

export const TopUSStocksColumns = [
  {
    title: '1-5',
    listItem: [
      {
        title: 'Apple',
        relative_path: '/us-stocks/apple-inc-share-price-aapl',
      },
      {
        title: 'Berkshire Hathaway',
        relative_path:
          '/us-stocks/berkshire-hathaway-inc-class-a-share-price-brk.a',
      },
      {
        title: 'Tesla',
        relative_path: '/us-stocks/tesla-inc-share-price-tsla',
      },
      {
        title: 'Alphabet',
        relative_path:
          '/us-stocks/alphabet-inc-class-a-shares-share-price-googl',
      },
      {
        title: 'Amazon',
        relative_path: '/us-stocks/amazon-com-inc-share-price-amzn',
      },
    ],
  },
  {
    title: '6-10',
    listItem: [
      {
        title: 'Coca-Cola',
        relative_path: '/us-stocks/coca-cola-company-the-share-price-ko',
      },
      {
        title: 'Nvidia',
        relative_path: '/us-stocks/nvidia-corporation-share-price-nvda',
      },
      {
        title: 'Microsoft',
        relative_path: '/us-stocks/microsoft-corporation-share-price-msft',
      },
      {
        title: 'Starbucks',
        relative_path: '/us-stocks/starbucks-corporation-share-price-sbux',
      },
      {
        title: 'PepsiCo',
        relative_path: '/us-stocks/pepsico-inc-share-price-pep',
      },
    ],
  },
  {
    title: '11-15',
    listItem: [
      {
        title: 'Uber',
        relative_path: '/us-stocks/uber-technologies-inc-share-price-uber',
      },
      {
        title: 'Oracle',
        relative_path: '/us-stocks/oracle-corp-share-price-orcl',
      },
      {
        title: 'Walmart',
        relative_path: '/us-stocks/walmart-inc-share-price-wmt',
      },
      {
        title: 'Netflix',
        relative_path: '/us-stocks/netflix-inc-share-price-nflx',
      },
      {
        title: 'Freshworks',
        relative_path: '/us-stocks/freshworks-share-price-frsh',
      },
    ],
  },
  {
    title: '16-20',
    listItem: [
      {
        title: 'BlackRock',
        relative_path: '/us-stocks/blackrock-inc-share-price-blk',
      },
      {
        title: 'Salesforce',
        relative_path: '/us-stocks/salesforce-inc-share-price-crm',
      },
      {
        title: 'Citigroup',
        relative_path: '/us-stocks/citigroup-inc-share-price-c',
      },
      {
        title: 'Cognizant Technology Solutions',
        relative_path:
          '/us-stocks/cognizant-technology-solutions-corp-share-price-ctsh',
      },
      {
        title: 'Intel',
        relative_path: '/us-stocks/intel-corporation-share-price-intc',
      },
    ],
  },
]

export const USStocksCategoryColumns = [
  {
    title: 'Technology & Digital Innovation',
    listItem: [
      {
        title: 'E-commerce',
        relative_path: '/us-stocks/catalogue/ecommerce',
      },
      {
        title: 'Social Media',
        relative_path: '/us-stocks/catalogue/social_media',
      },
      {
        title: 'Metaverse',
        relative_path: '/us-stocks/catalogue/metaverse',
      },
      {
        title: 'AI',
        relative_path: '/us-stocks/catalogue/ai',
      },
      {
        title: 'FAANG',
        relative_path: '/us-stocks/faang',
      },
    ],
  },
  {
    title: 'Industry & Lifestyle',
    listItem: [
      {
        title: 'Travel',
        relative_path: '/us-stocks/catalogue/travel_and_leisure',
      },
      {
        title: 'Healthcare',
        relative_path: '/us-stocks/catalogue/healthcare',
      },

      {
        title: 'Energy',
        relative_path: '/us-stocks/top-energy',
      },
      {
        title: 'Electric',
        relative_path: '/us-stocks/catalogue/electric%20Mobility',
      },
      {
        title: 'Sports',
        relative_path: '/us-stocks/catalogue/sports',
      },
    ],
  },
  {
    title: 'US Stocks Collections',
    listItem: [
      {
        title: 'Top Tech',
        relative_path: '/us-stocks/top-tech-stocks',
      },
      {
        title: 'Top Brands',
        relative_path: '/us-stocks/catalogue/top_brands',
      },
      {
        title: 'By Market Cap',
        relative_path: '/us-stocks/catalogue/market_cap',
      },
      {
        title: 'High Growth',
        relative_path: '/us-stocks/catalogue/high_growth',
      },
      {
        title: 'Celebrity',
        relative_path: '/us-stocks/catalogue/celebrity_investors',
      },
    ],
  },
  {
    title: 'US Stocks Categories',
    listItem: [
      {
        title: 'Top Gainers',
        relative_path: '/us-stocks/top-gainers',
      },
      {
        title: 'Top Losers',
        relative_path: '/us-stocks/top-losers',
      },
      {
        title: 'Pharma Stocks',
        relative_path: '/us-stocks/us-pharma-companies',
      },
      {
        title: 'US Stocks Basket',
        relative_path: '/us-stocks/catalogue/us_baskets',
      },
      {
        title: 'US Stocks Screener',
        relative_path: '/us-stocks/screener',
      },
    ],
  },
]

// Main footer links config

export const FooterV2Links: TFooterV2Links[] = [
  {
    title: '',
    rowsData: [
      {
        title: 'Top Indian Stocks',
        columnsData: TopIndianStocksColumns,
      },
      {
        title: 'Indian Stocks Category',
        columnsData: IndianStocksCategoryColumns,
      },
      {
        title: 'Top Indices',
        columnsData: TopIndicesColumns,
      },
      {
        title: 'Top US Stocks',
        columnsData: TopUSStocksColumns,
      },
    ],
  },
  {
    title: '',
    rowsData: [
      {
        title: 'US Stocks Category',
        columnsData: USStocksCategoryColumns,
      },
      {
        title: 'Top Mutual Funds',
        columnsData: TopMutualFundsColumns,
      },
      {
        title: 'Top Mutual Fund AMCs',
        columnsData: TopMutualFundAMCsColumns,
      },
      {
        title: 'Mutual Fund Category',
        columnsData: MutualFundsCategoryColumns,
      },
    ],
  },
  {
    title: '',
    rowsData: [
      {
        title: 'Tools and Calculators',
        columnsData: ToolsAndCalculatorsColumns,
      },

      {
        title: 'More',
        columnsData: MoreColumns,
      },
    ],
  },
]
